import { createSmileExpressionFrames } from "../../core/expression-keyframes.js";

export const meta = Object.freeze({
  id: "giggle-bounce",
  label: "Kicher-Hüpfer",
  duration: 1760,
  description: "Lachaugen und fünf schnelle kleine Hüpfer wie bei einem echten Kicheranfall.",
  tags: ["body", "expression", "rhythm", "one-shot", "loopable"],
});

export async function run({ elements, animate }) {
  const expression = createSmileExpressionFrames({
    enterStart: .025,
    enterCross: .05,
    enterEnd: .075,
    exitStart: .86,
    exitCross: .89,
    exitEnd: .92,
    settleEnd: .96,
    smileHoldFrames: [
      { opacity: 1, transform: "scale(.98, .94) translateY(1px)", offset: .30 },
      { opacity: 1, transform: "scale(1.045, 1.04) translateY(0)", offset: .56 },
      { opacity: 1, transform: "scale(1, 1) translateY(0)", offset: .80 },
    ],
  });

  const bodyFrames = [
    { transform: "translateY(0) scale(1, 1) rotate(0deg)", offset: 0 },
    { transform: "translateY(2px) scale(1.07, .93) rotate(0deg)", offset: .05 },
    { transform: "translateY(-14px) scale(.98, 1.04) rotate(-1.6deg)", offset: .11 },
    { transform: "translateY(2px) scale(1.075, .925) rotate(.8deg)", offset: .17 },
    { transform: "translateY(-11px) scale(.985, 1.035) rotate(1.8deg)", offset: .23 },
    { transform: "translateY(2px) scale(1.07, .93) rotate(-.8deg)", offset: .29 },
    { transform: "translateY(-16px) scale(.975, 1.05) rotate(-1.2deg)", offset: .35 },
    { transform: "translateY(2px) scale(1.08, .92) rotate(.8deg)", offset: .41 },
    { transform: "translateY(-12px) scale(.985, 1.04) rotate(1.5deg)", offset: .48 },
    { transform: "translateY(2px) scale(1.07, .93) rotate(-.6deg)", offset: .55 },
    { transform: "translateY(-14px) scale(.98, 1.045) rotate(-1deg)", offset: .62 },
    { transform: "translateY(2px) scale(1.075, .925) rotate(.5deg)", offset: .69 },
    { transform: "translateY(-5px) scale(.995, 1.018) rotate(0deg)", offset: .77 },
    { transform: "translateY(0) scale(1, 1) rotate(0deg)", offset: .84 },
    { transform: "translateY(0) scale(1, 1) rotate(0deg)", offset: 1 },
  ];

  const shadowFrames = [
    { transform: "scaleX(1)", opacity: .28, offset: 0 },
    { transform: "scaleX(1.12)", opacity: .34, offset: .05 },
    { transform: "scaleX(.70)", opacity: .17, offset: .11 },
    { transform: "scaleX(1.13)", opacity: .35, offset: .17 },
    { transform: "scaleX(.76)", opacity: .19, offset: .23 },
    { transform: "scaleX(1.12)", opacity: .34, offset: .29 },
    { transform: "scaleX(.67)", opacity: .15, offset: .35 },
    { transform: "scaleX(1.14)", opacity: .36, offset: .41 },
    { transform: "scaleX(.74)", opacity: .18, offset: .48 },
    { transform: "scaleX(1.12)", opacity: .34, offset: .55 },
    { transform: "scaleX(.70)", opacity: .17, offset: .62 },
    { transform: "scaleX(1.13)", opacity: .35, offset: .69 },
    { transform: "scaleX(.88)", opacity: .23, offset: .77 },
    { transform: "scaleX(1)", opacity: .28, offset: .84 },
    { transform: "scaleX(1)", opacity: .28, offset: 1 },
  ];

  const body = animate(elements.actor, bodyFrames, { duration: meta.duration, easing: "ease-in-out" });
  const shadow = animate(elements.shadow, shadowFrames, { duration: meta.duration, easing: "ease-in-out" });
  const openEyes = animate(elements.openEyes, expression.openEyes, { duration: meta.duration, easing: "linear" });
  const smileEyes = animate(elements.smileEyes, expression.smileEyes, { duration: meta.duration, easing: "linear" });
  const glow = animate(elements.glow, [
    { opacity: .48, offset: 0 },
    { opacity: .76, offset: .12 },
    { opacity: .62, offset: .30 },
    { opacity: .78, offset: .49 },
    { opacity: .64, offset: .68 },
    { opacity: .48, offset: 1 },
  ], { duration: meta.duration, easing: "ease-in-out" });

  await Promise.allSettled([body.finished, shadow.finished, openEyes.finished, smileEyes.finished, glow.finished]);
}
